<template>
  <div :class="`${$style.detail} ${!hiddenTitle ? $style.detailT : ''}`">
    <header v-if="!hiddenTitle">
      <div @click="goBack">
        <i class="iconfont yw-xiangzuo"></i>
      </div>
      <span>{{ detailTitle }}</span>
    </header>
    <div :class="$style.box">
      <p :class="$style.title">{{detailContent ? detailContent.title : ''}}</p>
      <p :class="$style.time">{{detailContent ? detailContent.createTime : ''}}</p>
      <p
        :class="$style.content"
        v-html="detailContent ? detailContent.info.replace(/(\r\n|\n|\r)/gm, '<br />') : ''"
      ></p>
    </div>
  </div>
</template>

<script>

import { setPageTitle } from '@/bridge/AppJsBridge';
import { checkIsWxBrowser, getCookie } from "@/libs/utils";
import { getNoticeDetail } from "@/apis/btGameSubscribe";

export default {
  data() {
    return {
      detailTitle: "公告详情",
      detailContent: null,
      hiddenTitle: false,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      const { history } = this.$router;
      const { query } = history.current;
      setPageTitle(query.title);
      this.detailTitle = query.title;
      if (query.data) {
        getNoticeDetail(query.data).then(res => {
          this.detailContent = res.data;
        })
      }
      
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.hiddenTitle = true;
      }

      if (checkIsWxBrowser()) {
        this.hiddenTitle = true;
      }
    },
    goBack() {
      this.$router.back()
    },
  },
};
</script>

<style lang="scss" module>
.detailT{
  padding-top: 50px;
}
.detail {
  width: 100%;
  height: 100vh;
  max-width: 375px;
  margin: auto;
  background: #f1f1f1;
  overflow: auto;
  &.hiddenTitle {
    padding-top: 0px;
    > header {
      display: none;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 3;
    background: #ffffff;
    color: #000000;
    font-size: 19px;
    padding: 14px 5px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-weight: bold;
      position: absolute;
    }
    > span {
      font-size: 18px;
      font-weight: 700;
      margin: 0 auto;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }

  .box{
    .title{
      font-size: 14.58px;
      font-weight: 500;
      text-align: center;
      color: #000000;
    }
    .time{
      height: 9.72px;
      font-size: 12.5px;
      font-weight: 400;
      color: #9f9f9f;
      line-height: 7.99px;
      text-align: center;
    }
  }
  .title {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans CN, Source Han Sans CN-Bold;
    font-weight: 700;
    color: black;
    line-height: 36px;
  }
  .content{
    margin: 10px 20px;
    color: #666666;
    font-weight: 500;
    font-size: 12.5px;
    line-height: 1.5;
    p,span {
      background: #f1f1f1 !important;
    }
    img{
      width: 100%;
    }

  }
  :global {
    .iconfont {
      font-size: 22px;
      margin-right: 5px;
    }
  }
}
</style>
